import {
  FDStack,
  FDLabelText,
  FDAccordion,
  FDAccordionTitle,
  FDAccordionDetails,
  FDList,
  FDTitleText,
} from '@facet-wealth/design';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BodyList from 'Components/ComponentLibrary/Molecules/BodyList';
import Resource from 'facet-rest/src/domain/Resource';

export default function AdditionalInfoAccordion({
  additionalInformationIncludedResource, currentSectionResource,
}) {
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  return (
    <FDAccordion expanded={isAccordionExpanded} onChange={() => setIsAccordionExpanded(!isAccordionExpanded)}>
      <FDAccordionTitle>
        <FDStack direction={'column'}>
          {currentSectionResource.attr('title') && <FDTitleText size={'lg'} value={currentSectionResource.attr('title')} />}
          {currentSectionResource.attr('subTitle') && <FDLabelText size={'lg'} value={currentSectionResource.attr('subTitle')} />}
        </FDStack>
      </FDAccordionTitle>
      <FDAccordionDetails>
        <FDStack spacing={2} direction={'column'}>
          {additionalInformationIncludedResource.attr('additionalInfoTitle') && <FDLabelText size={'lg'} value={additionalInformationIncludedResource.attr('additionalInfoTitle')} />}
          <FDStack direction={'column'}>
            {additionalInformationIncludedResource.attr('additionalInfoSubTitle') && <FDLabelText size={'lg'} value={additionalInformationIncludedResource.attr('additionalInfoSubTitle')} />}
            <FDList>
              <BodyList value={additionalInformationIncludedResource.attr('additionalInfoDetails')} size={'sm'} />
            </FDList>
          </FDStack>
        </FDStack>
      </FDAccordionDetails>
    </FDAccordion>
  );
}
AdditionalInfoAccordion.propTypes = {
  additionalInformationIncludedResource: PropTypes.instanceOf(Resource).isRequired,
  currentSectionResource: PropTypes.instanceOf(Resource).isRequired,
};
